/**
Copyright [2022] [https://www.merac.com
 */
import tool from '@/utils/tool'

const normalizePermissionCode = (value) =>
	String(value || '')
		.trim()
		.toUpperCase()

const matchPermission = (permissionCodePool, permissionCode) => {
	const normalizedCode = normalizePermissionCode(permissionCode)
	return (
		Boolean(normalizedCode) &&
		(permissionCodePool || []).some((item) => normalizePermissionCode(item) === normalizedCode)
	)
}

const collectPermissionCodes = (userInfo = {}) => {
	const capabilityCodes = Array.isArray(userInfo.capabilityCodes) ? userInfo.capabilityCodes : []
	return capabilityCodes
}

const hasSuperAdminRole = (userInfo = {}) =>
	Array.isArray(userInfo.roleCodeList) &&
	userInfo.roleCodeList.some(
		(roleCode) =>
			String(roleCode || '')
				.trim()
				.toLowerCase() === 'superadmin'
	)

/**
 * 权限判断是否能看到这个按钮，同时后端也做了校验，前端只是显示与不显示
 * @param {string, array} data 按钮的权限点，可以是单个字符串，也可以是数组
 * @param {string} rule or代表或，and代表与
 * 使用方法：
 * 例如 capabilityCodes 的数据为： ['goods.catalog.view', 'staff.access.manage']
 * 判断商品维护权限：hasPerm('goods.catalog.manage')
 * 判断任一能力：hasPerm(['goods.catalog.view', 'goods.catalog.manage'])
 * 判断同时具备的能力：hasPerm(['goods.catalog.view', 'goods.catalog.manage'], 'and')
 */
export function hasPerm(data, rule = 'or') {
	if (!data) {
		return false
	}
	const userInfo = tool.data.get('USER_INFO')
	if (!userInfo) {
		return false
	}
	const permissionCodePool = collectPermissionCodes(userInfo)
	if (permissionCodePool.length === 0) {
		return false
	}
	if (Array.isArray(data)) {
		const fn = rule === 'or' ? 'some' : 'every'
		return data[fn]((item) => matchPermission(permissionCodePool, item))
	}
	return matchPermission(permissionCodePool, data)
}

export function isPlatformOperator(userInfo = tool.data.get('USER_INFO')) {
	return Boolean(userInfo && hasSuperAdminRole(userInfo))
}
